"use client"

import Image from "next/image"

export default function CustomLoader() {
  return (
    <div
      className={`fixed inset-0 flex flex-col items-center justify-center bg-white z-50 transition-opacity duration-500 opacity-100`}
    >
      <div className="flex flex-col items-center justify-center space-y-6">
        <div className="relative w-24 h-24 animate-spin-slow">
          <Image src="/logo2.png" alt="AI Interview Agents Logo" width={96} height={96} className="w-full h-full" priority />
        </div>

        <div className="flex items-center animate-fade-in-up">
          <span className="text-3xl font-bold text-[#1c3038]">AI Interview Agents</span>
        </div>

        <div className="text-sm text-gray-500 animate-fade-in">
          Loading your workspace<span className="animate-ellipsis">...</span>
        </div>
      </div>
    </div>
  )
}